import { Component } from '@angular/core';

@Component ( {
  selector: 'reporter-mfa-onboarding',
  templateUrl: './mfa-onboarding.component.html',
  standalone: false
} )
export class MfaOnboardingComponent {
}
